import { Skeleton } from 'antd';

const ShopItem = ({ item }) => {

  const {
    name = '',
    discount = '',
    discount_price = '',
    origin_price = '',
    url = '',
    cover,
  } = item;
  return (
    <div className="pl-15px pr-4px py-20px mb-16px rounded-8px bg-[#F5F5F5]">
      <a href={url} target="_blank" rel="noopener" className="flex items-left gap-16px">
        <div
          className="w-48px h-48px rounded-6px overflow-hidden shrink-0"
          style={{
            backgroundImage: `url(${cover})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            flexShrink: 0
          }}
        ></div>
        <div className="flex flex-1 flex-col justify-center gap-6px text-14px text-black w-full">
          {name && <div className="line-clamp-1" title={name}>{name}</div>}
          {discount && <div className="line-clamp-1 text-12px text-[#4a4a4a]">{discount}</div>}
            <div className="text-12px flex items-center gap-12px">
              {discount_price && (<span className="text-[#FF3B30]">
                <span>价格：</span>
                <span className="text-14px font-bold">{discount_price}</span>
              </span>)}
              {origin_price && <span className={`text-[#4a4a4a] ${discount_price ? 'line-through' : ''}`}>原价：{origin_price}</span>}
            </div>
        </div>
      </a>
    </div>
  );
}

const CardAnalysisTool = ({ data }) => {
  return (
    <div className="px-24px pr-16px mr-4px mb-16px flex-grow overflow-x-hidden overflow-y-auto scrollbar">
      {data?.length === 0 ? (
        <Skeleton active />
      ) : (
        data.map((item, index) => {
          return <ShopItem key={`analysis-tool-${index}`} item={item} />;
        })
      )}
    </div>
  );
};

export default CardAnalysisTool;
